import type { ReactNode } from 'react'

/**
 * The title of a screen and the one action it is about — outside the cards rather than in a
 * CardHeader, so every screen starts at the same place and the cards below stay about content.
 *
 * No description line. Every screen had one explaining what the screen obviously was, and a
 * sentence that is read once and skipped forever is a sentence that costs vertical space on every
 * visit. What genuinely needs saying belongs where it applies — on the control, as a hint under a
 * field, or in a tooltip.
 */
export function PageHeader({
  title,
  children,
}: {
  title: ReactNode
  /** Rendered top right: the one action the page is about, if it has one. */
  children?: ReactNode
}) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-3">
      <h1 className="font-heading text-2xl leading-tight font-semibold tracking-tight text-balance">
        {title}
      </h1>
      {children && <div className="flex shrink-0 items-center gap-2">{children}</div>}
    </div>
  )
}
